(ns manage.content-configuration-page.context-source.macro
  (:require [manage.content-configuration-page.context-source.create-modal :as create-modal]
            [manage.content-configuration-page.context-source.schema :as s]
            [re-frame.core :as rf]
            [reagent.ratom :as ratom]))

(defn- macro-label [alias selector-schema separator]
  (str alias separator (:label selector-schema)))

(rf/reg-sub :macro/icon
  (fn [[_ m]]
    (rf/subscribe [:ui.store/pull-entity [{:context-source/_macro [:context-source/schema]}] m]))
  (fn [{{:context-source/keys [schema]} :context-source/_macro} _]
    (s/schema-id->icon schema)))

(rf/reg-sub :macro/label
  (fn [[_ {context-source :context-source/_macro :macro/keys [selector]} _]]
    (rf/subscribe [:context-source/selector-schemas context-source selector]))
  (fn [selector-schema [_ {context-source :context-source/_macro} separator]]
    (macro-label (:context-source/alias context-source) selector-schema separator)))

(rf/reg-sub-raw :context-source/all-macro-options
  (fn [_ [_ exclude-aliases]]
    (ratom/reaction
     (->>
      (for [{:context-source/keys [alias schema] :as context-source}
            @(rf/subscribe [:manage.content-configuration-page.context-source.db/context-sources])
            :when (not (contains? exclude-aliases alias))
            [selector selector-schema] @(rf/subscribe [:context-source/selector-schemas context-source])
            :when (not (:limited-to-assignments selector-schema))]
        {:value (pr-str {:macro/selector [selector]
                         :context-source/_macro [:context-source/alias alias]})
         :icon (s/schema-id->icon schema)
         :label (macro-label alias selector-schema " - ")})
      doall
      (sort-by :label)))))

(rf/reg-sub :context-source/all-macro-options-with-create-option
  (fn [[_ exclude-aliases]]
    (rf/subscribe [:context-source/all-macro-options exclude-aliases]))
  (fn [all-macro-options _]
    (conj all-macro-options
          {:icon "add"
           :label create-modal/title
           :on-click #(rf/dispatch [:modal.context-source/open])})))

